import React, { useState } from 'react';
import { ButtonContainer } from '../jsxElements/Button';
import styles from './Dropdown.module.css';

import { AmpFlagSet } from '../amplitude';

type Choice = {
    title: string;
    value: string;
};

// TODO: reconcile diff b/w infermedica multiselect and covid vaccine triage multiselect
export interface DropdownAttachmentData {
    actions: any[];
    body: {
        type: string;
        choices: Choice[];
    }[];
    type: string;
}

const DropdownBox: React.FC<{
    choices: Choice[];
    disableButtons: boolean;
    messageText: string;
    selected: string;
    setSelected: React.Dispatch<React.SetStateAction<string>>;
}> = ({ choices, disableButtons, messageText, selected, setSelected }) => {
    const handleChange: (e: React.ChangeEvent<HTMLSelectElement>) => void = (
        e
    ) => {
        setSelected(e.target.value);
    };
    return (
        <select
            aria-label={messageText}
            className={styles.dropdownSelectBox}
            disabled={disableButtons}
            onChange={(e) => handleChange(e)}
            value={selected}
        >
            {choices.map((choice) => (
                <option
                    aria-label={choice.value}
                    key={choice.value}
                    value={choice.value}
                >
                    {choice.title}
                </option>
            ))}
        </select>
    );
};

const DropdownAttachment: React.FC<{
    data: DropdownAttachmentData;
    disableButtons: boolean;
    featureFlags: AmpFlagSet;
    messageText: string;
    sendPostBack: (message: any) => void;
}> = ({ data, disableButtons, featureFlags, messageText, sendPostBack }) => {
    const [optionSelected, setOptionSelected] = useState('');
    const choices = data.body[0].choices;
    const submitButtonText = data.actions[0].title;
    return (
        <div className={styles.dropdown}>
            <DropdownBox
                choices={choices}
                disableButtons={disableButtons}
                messageText={messageText}
                selected={optionSelected}
                setSelected={setOptionSelected}
            />
            <ButtonContainer
                buttons={[
                    {
                        button: {
                            title: submitButtonText,
                        },
                        disableButtons,
                        featureFlags,
                        index: 0,
                        overrideStyle: optionSelected ? '' : 'disable',
                        overrideSendMessage: () => {
                            const selected = choices.find(
                                (choice) => choice.value === optionSelected
                            ) || { value: '', title: '' };
                            sendPostBack({
                                choice: selected.value,
                                title: selected.title,
                            });
                        },
                    },
                ]}
                featureFlags={featureFlags}
            />
        </div>
    );
};

export const Dropdown = DropdownAttachment;
